import { useEffect, useState, useCallback, useContext } from "react";
import { useLocation } from "@reach/router";
import useQueryParams from "./useQueryParams";
import { BOOKING_CODE_REGEX } from "store/constants/regexes";
import PageContext from "contexts/PageContext";

const useBookingCode = (bookingCodeFromProps) => {
  const { booking_code = "" } = useQueryParams();
  const { search } = useLocation();
  const [bookingCode, setBookingCode] = useState(bookingCodeFromProps);
  const { ignoreBookingCodeFromUrl } = useContext(PageContext);

  const takeBookingCodeFromUrl = !ignoreBookingCodeFromUrl;

  const setBookingCodeWrapper = useCallback(
    (code) => {
      const sanitizeCode = code.replace(BOOKING_CODE_REGEX, "");
      if (sanitizeCode !== "" || code === "") {
        setBookingCode(sanitizeCode.toUpperCase());
      }
    },
    [bookingCode, booking_code, search]
  );

  useEffect(() => {
    const bookingCodeNotUpdatedYet = bookingCode === undefined;
    const updateBookingCode =
      bookingCodeNotUpdatedYet && booking_code && takeBookingCodeFromUrl;

    if (updateBookingCode) {
      setBookingCodeWrapper(booking_code);
    }
  }, [
    bookingCode,
    booking_code,
    setBookingCodeWrapper,
    takeBookingCodeFromUrl,
  ]);

  return [
    bookingCode,
    takeBookingCodeFromUrl ? setBookingCodeWrapper : setBookingCode,
  ];
};

export default useBookingCode;
